import React from "react";
import { Check } from "react-feather";
import styles from "./addTenant.module.css";

const StepperHeader = ({ steps, step, goToStep }) => {
  return (
    <nav aria-label="Steps" className={styles.StepperHeader}>
      {steps.map((label, index) => {
        const stepNo = index + 1;
        const isDone = stepNo < step;
        const isCurrent = stepNo === step;

        return (
          <div className={styles.StepItem} key={label}>
            <button
              type="button"
              className={`${styles.StepButton} ${isCurrent ? styles.Current : ""} ${isDone ? styles.Done : ""}`}
              aria-current={isCurrent ? "step" : undefined}
              disabled={!isDone}
              onClick={() => goToStep(stepNo)}
            >
              <span className={styles.StepCircle}>{isDone ? <Check /> : stepNo}</span>
              <span className={styles.StepLabel}>{label}</span>
            </button>
            {stepNo < steps.length && <span className={styles.StepLine} />}
          </div>
        );
      })}
    </nav>
  );
};

export default StepperHeader;
